import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/features/modalSlice";

function EditTestimonial({ data }) {

  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: data?.name || "",
    designation: data?.designation || "",
    description: data?.description || "",
    image: data?.image || "",
    status: data?.status || "",
  });

  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  };

  const handleUpdate = async () => {

    try {

      console.log(formData);

      // API CALL HERE

      dispatch(closeModal());

    } catch (error) {

      console.log(error);

    }
  };

  return (
    <>
      <div className="custom-modal-body">

        <div className="model-custum">

          <div className="edit-form-group">

            <label>Name</label>

            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="form-control"
            />

          </div>

          <div className="edit-form-group">

            <label>Designation</label>

            <input
              type="text"
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              className="form-control"
            />

          </div>

          <div className="edit-form-group">

            <label>Description</label>

            <textarea
              rows="4"
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="form-control"
            />

          </div>

          <div className="edit-form-group">

            <label>Image URL</label>

            <input
              type="text"
              name="image"
              value={formData.image}
              onChange={handleChange}
              className="form-control"
            />

          </div>

          <div className="edit-form-group">

            <label>Status</label>

            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="form-control"
            >

              <option value="Active">
                Active
              </option>

              <option value="Inactive">
                Inactive
              </option>

            </select>

          </div>

        </div>

      </div>

      <div className="modal-btn-group">

        <button
          className="cancel-btn"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        <button
          className="save-btn"
          onClick={handleUpdate}
        >
          Save Changes
        </button>

      </div>
    </>
  );
}

export default EditTestimonial;